module.exports = __webpack_public_path__ + "static/media/fail.e766e5a2.gif";